<!--TODO: Nirav style error message however you want-->
<mat-error>
  <p *ngIf="message">{{message.text}}</p>
</mat-error>
